const createArrowpaySubmissionLock = () => {
    let locked = false;
    let tokenCallbackHandled = false;
    let paymentAttemptId = null;

    return {
        tryAcquire(nextPaymentAttemptId) {
            if (locked) {
                return false;
            }

            locked = true;
            tokenCallbackHandled = false;
            paymentAttemptId = nextPaymentAttemptId;
            return true;
        },

        tryHandleTokenCallback() {
            if (!locked || tokenCallbackHandled) {
                return false;
            }

            tokenCallbackHandled = true;
            return true;
        },

        getPaymentAttemptId() {
            return paymentAttemptId;
        },

        release() {
            locked = false;
            tokenCallbackHandled = false;
            paymentAttemptId = null;
        },
    };
};

module.exports = { createArrowpaySubmissionLock };
